import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import LandingNavbar from "@/components/landing/LandingNavbar";
import HeroSection from "@/components/landing/HeroSection";
import PersonalizationDemo from "@/components/landing/PersonalizationDemo";
import BenefitsSection from "@/components/landing/BenefitsSection";
import ThemesSamplesSection from "@/components/landing/ThemesSamplesSection";
import SocialProofSection from "@/components/landing/SocialProofSection";
import WhyAISection from "@/components/landing/WhyAISection";
import PricingSection from "@/components/landing/PricingSection";
import FAQSection from "@/components/landing/FAQSection";
import LandingFooter from "@/components/landing/LandingFooter";
import WaveDivider from "@/components/landing/WaveDivider";

const getAuthErrorMessage = (errorCode: string, errorDescription: string): { title: string; description: string } => {
  switch (errorCode) {
    case "otp_expired":
      return {
        title: "Link Expired",
        description: "Your verification link has expired. Please sign up again or request a new link.",
      };
    case "access_denied":
      return {
        title: "Access Denied",
        description: errorDescription || "Access was denied. Please try again.",
      };
    case "invalid_request":
      return {
        title: "Invalid Request",
        description: "The request was invalid. Please try signing up again.",
      };
    default:
      return {
        title: "Authentication Error",
        description: errorDescription || "An error occurred during authentication. Please try again.",
      };
  }
};

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // No longer redirect logged-in users - they can view landing page
    // Redirect only happens on auth page

    // Check for auth errors in URL hash
    const hash = window.location.hash;
    if (hash && hash.includes("error=")) {
      const params = new URLSearchParams(hash.substring(1));
      const error = params.get("error");
      const errorCode = params.get("error_code");
      const errorDescription = params.get("error_description")?.replace(/\+/g, " ");

      if (error) {
        const { title, description } = getAuthErrorMessage(errorCode || "", errorDescription || "");
        
        toast({
          variant: "destructive",
          title,
          description,
          action: errorCode === "otp_expired" ? (
            <button
              onClick={() => navigate("/auth")}
              className="text-sm underline hover:no-underline"
            >
              Sign up again
            </button>
          ) : undefined,
        });

        // Clean up the URL hash
        window.history.replaceState(null, "", window.location.pathname);
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      <LandingNavbar />
      <main>
        <HeroSection />
        <WaveDivider color="pink" />
        <PersonalizationDemo />
        <WaveDivider color="purple" />
        <BenefitsSection />
        <WaveDivider color="teal" />
        {/* <ThemesSamplesSection />
        <WaveDivider color="yellow" /> */}
        {/* <SocialProofSection />
        <WaveDivider color="orange" /> */}
        <WhyAISection />
        <WaveDivider color="pink" />
        {/* <PricingSection />
        <WaveDivider color="purple" /> */}
        <FAQSection />
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
